/**
 * Animation Utilities (React)
 *
 * Re-exports the shared animation utilities for use in the React package.
 * All animation logic is in shared/doc/utils.
 */

export {
  getAnimationStyle,
  getDefaultAnimationDuration,
  getTransitionClass,
  getAnimationProgress,
} from '@bendyline/squisq/doc';
